import React, { useEffect, useRef, useState } from "react";
import "../index.css";
import TagStatus from "./TagStatus";
import { webNavigate } from "../services/navigate.service";
import Loading from "./Loading";
import SalesIcons from "../images/SalesIcons";
import DotIcon from "../images/DotIcon";
import PurchasesIconMobile from "../images/PurchasesIconMobile";
import DotIconBlack from "../images/DotIconBlack";
import ArrowClientsIcon from "../images/ArrowClientsIcon";

const PER_PAGE = 50;

interface PropTable {
    data_table?: Record<string, any>[];
    modules?: string;
    loading: boolean,
    listAsset?: any,
    noRedirect?: boolean,
    listLedger?: any,
    optionSelect?: boolean,
    actionCompany?: {
        check: boolean;
        name: string;
    }
    hiddenAction?: boolean,
    count: number;
    noNagivateClick?: {
        check: boolean;
        name?: string;
    };
    path?: string;
    titleCreate?: {
        title?: string;
        path?: string;
        desc?: string;
        titleCreate?: string;
    };
    dynamicFields: string[];
    handlePeriod?: (id: string) => void;
    languages?: any;
    hiddenLedger?: boolean;
    handleSendPageNumber: (pageNumber: number) => void;
    handleDelete?: (id: string) => void;
    handleLocation?: (id: string) => void;
    handleRedirect?: () => void;
    handleYear?: (id: string) => void;
    handleDeletePurchase?: (id: string, type: string) => void;
}

const TableReportMobile = ({
    data_table,
    count,
    dynamicFields,
    path,
    loading,
    modules,
    handleLocation,
    handlePeriod,
    handleYear,
    listLedger,
    languages,
    noNagivateClick,
    listAsset
}: PropTable) => {
    const [data, setData] = useState<Record<string, any>[]>();
    const monthRef = useRef<HTMLDivElement>(null);
    const preLanguage = localStorage.getItem("language");
    const [searchCountry, setSearchCountry] = useState("");
    const dropdownYearRef = useRef<HTMLDivElement>(null);
    const [searchYear, setSearchYear] = useState("");
    const [isYearDropdownOpen, setIsYearDropdownOpen] = useState(false);
    const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
    const dropdownCountryRef = useRef<HTMLDivElement>(null);
    const [showActions, setShowActions] = useState<boolean[]>(data ? new Array(data.length).fill(false) : []);
    const [isMonthDropdownOpen, setIsMonthDropdownOpen] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState<string>("");
    const actionRefs = useRef<(HTMLDivElement | null)[]>([]);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [name, setName] = useState<string>("");
    const [checkClient, setCheckClient] = useState<any>({ checkValue: false, name: "" });
    const totalPages = data ? Math.ceil(count / PER_PAGE) : 0;
    const pages = Array.from({ length: totalPages }, (_, index) => index + 1);
    const startItem = (pageNumber - 1) * PER_PAGE;
    const endItem = Math.min(pageNumber * PER_PAGE, count);
    let numberOfKeys = data && data[0] ? Object.keys(data[0]) : [];

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            actionRefs.current.forEach((ref, index) => {
                if (ref && !ref.contains(event.target as Node)) {
                    setShowActions(prev => {
                        const newShowActions = [...prev];
                        newShowActions[index] = false;
                        return newShowActions;
                    });
                }
            });
            if (monthRef.current && !monthRef.current.contains(event.target as Node)) {
                setIsMonthDropdownOpen(false);
            }
            if (dropdownCountryRef.current && !dropdownCountryRef.current.contains(event.target as Node)) {
                setIsCountryDropdownOpen(false);
            }
            if (dropdownYearRef.current && !dropdownYearRef.current.contains(event.target as Node)) {
                setIsYearDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleSelectLocation = (location: any) => {
        setSearchCountry(location === "location" ? "" : location.name);
        setIsCountryDropdownOpen(false);
        if (handleLocation) {
            handleLocation(location === "location" ? "location" : location.id);
        }
    };

    const handleSelectYear = (year: any) => {
        setSearchYear(year === "year" ? "" : year.year);
        setIsYearDropdownOpen(false);
        if (handleYear) {
            handleYear(year === "year" ? "year" : year.year);
        }
    };

    const handleSelectPeriod = (month: any) => {
        setSelectedMonth(month === "period" ? "" : String(month.transactionYear + ' - ' + month.monthSequence));
        setIsMonthDropdownOpen(false);
        if (handlePeriod) {
            handlePeriod(month === "period" ? "period" : month.id);
        }
    };

    useEffect(() => {
        setData(data_table);
    }, [data_table])

    return (
        <>
            <div className="lg:hidden" style={{ height: noNagivateClick?.check ? "calc(48% - 100px)" : "100%" }}>
                {loading ? (
                    <Loading />
                ) : (
                    <>
                        {(listLedger?.location && modules === "Stocks") && (
                            <div className="absolute" style={{ top: "7px", right: "12px" }} ref={dropdownCountryRef}>
                                <input
                                    tabIndex={13}
                                    type="text"
                                    value={searchCountry}
                                    style={{ pointerEvents: 'all', width: "124px", color: "#424242", placeContent: "#424242" }}
                                    onChange={(e) => {
                                        setSearchCountry(e.target.value);
                                        setIsCountryDropdownOpen(true);
                                    }}
                                    onClick={() => setIsCountryDropdownOpen(true)}
                                    className={`text-[14px] font-inter p-3 rounded-lg outline-none focus-none bg-transparent`}
                                />
                                {isCountryDropdownOpen && (
                                    <div className="absolute z-10 mt-1 bg-white border border-[#EBEBED] rounded-lg max-h-60 overflow-auto p-1 shadow-extend" style={{ width: "124px" }}>
                                        <div
                                            style={{ padding: "8px 6px", borderRadius: "4px" }}
                                            className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                            onClick={() => handleSelectLocation("location")}
                                        >
                                            Select location
                                        </div>
                                        {listLedger?.location.map((country: any) => (
                                            <div
                                                key={country?.id}
                                                style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                                onClick={() => handleSelectLocation(country)}
                                            >
                                                {country?.name}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}

                        {(listAsset && listAsset.length > 0) && (
                            <div className="relative" ref={dropdownYearRef}>
                                <input
                                    tabIndex={13}
                                    type="text"
                                    value={searchYear}
                                    style={{ pointerEvents: 'all', width: "180px" }}
                                    onChange={(e) => {
                                        setSearchYear(e.target.value);
                                        setIsYearDropdownOpen(true);
                                    }}
                                    onClick={() => setIsYearDropdownOpen(true)}
                                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-lg outline-none focus-none bg-white`}
                                />
                                {isYearDropdownOpen && (
                                    <div className="absolute z-10 mt-1 bg-white border border-[#EBEBED] rounded-lg max-h-60 overflow-auto p-1 shadow-extend" style={{ width: "180px" }}>
                                        <div
                                            style={{ padding: "8px 6px", borderRadius: "4px" }}
                                            className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                            onClick={() => handleSelectYear("year")}
                                        >
                                            Select year
                                        </div>
                                        {listAsset.map((asset: any) => (
                                            <div
                                                key={asset?.id}
                                                style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                                onClick={() => handleSelectYear(asset)}
                                            >
                                                {asset?.year}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}

                        {listLedger?.location && listLedger?.period && (
                            <div className="flex items-center absolute" style={{ gap: "4px", padding: "0px 12px", top: "138px" }}>
                                {listLedger?.period && (
                                    <div className="relative" ref={monthRef}>
                                        <input
                                            type="text"
                                            value={selectedMonth}
                                            onChange={(e) => {
                                                setSelectedMonth(e.target.value);
                                                setIsMonthDropdownOpen(true);
                                            }}
                                            onClick={() => setIsMonthDropdownOpen(true)}
                                            style={{ pointerEvents: 'all', width: "180px" }}
                                            tabIndex={11}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border p-3 rounded-lg outline-none focus-none bg-transparent`}
                                        />
                                        {isMonthDropdownOpen && (
                                            <div className="absolute z-[100] mt-1 bg-white border border-[#EBEBED] rounded-lg p-1 shadow-extend" style={{ width: "180px" }}>
                                                <div className="w-full h-full relative">
                                                    <div
                                                        style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                        className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                                        onClick={() => handleSelectPeriod("period")}
                                                    >
                                                        Select period
                                                    </div>
                                                    {listLedger?.period.map((month: any) => (
                                                        <div
                                                            key={month.id}
                                                            style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                            className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                                            onClick={() => handleSelectPeriod(month)}
                                                        >
                                                            {month.transactionYear} - {month.monthSequence}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {listLedger?.location && (
                                    <div className="relative" ref={dropdownCountryRef}>
                                        <input
                                            tabIndex={13}
                                            type="text"
                                            value={searchCountry}
                                            style={{ pointerEvents: 'all', width: "180px" }}
                                            onChange={(e) => {
                                                setSearchCountry(e.target.value);
                                                setIsCountryDropdownOpen(true);
                                            }}
                                            onClick={() => setIsCountryDropdownOpen(true)}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border p-3 rounded-lg outline-none focus-none bg-transparent`}
                                        />
                                        {isCountryDropdownOpen && (
                                            <div className="absolute z-10 mt-1 bg-white border border-[#EBEBED] rounded-lg max-h-60 overflow-auto p-1 shadow-extend" style={{ width: "180px" }}>
                                                <div
                                                    style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                    className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                                    onClick={() => handleSelectLocation("location")}
                                                >
                                                    Select location
                                                </div>
                                                {listLedger?.location.map((country: any) => (
                                                    <div
                                                        key={country?.id}
                                                        style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                        className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                                        onClick={() => handleSelectLocation(country)}
                                                    >
                                                        {country?.name}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}

                        {noNagivateClick?.check && (
                            <div className="flex items-center justify-between cursor-pointer" style={{ padding: "12px 6px" }}>
                                <p className="font-inter" style={{ color: "#2A2A2A", fontSize: "18px", fontWeight: "400", lineHeight: "23.4px" }}>
                                    {noNagivateClick?.name}
                                </p>
                                <div
                                    className="flex items-center justify-center"
                                    style={{
                                        width: "32px",
                                        height: "32px",
                                        padding: "4px",
                                        rotate: checkClient?.checkValue ? "180deg" : "0deg",
                                        transition: "0.3s ease-in-out"
                                    }}
                                >
                                    <ArrowClientsIcon />
                                </div>
                            </div>
                        )}

                        {(data ?? []).map((item: any, itemIndex: number) => {
                            return (
                                <div
                                    className="w-full cursor-pointer"
                                    key={item.id || itemIndex}
                                    style={{
                                        padding: "8px 16px",
                                        cursor: "pointer",
                                        backgroundColor: "white",
                                        marginBottom: "4px",
                                    }}
                                    onClick={() => {
                                        (path && path?.length > 0) ? webNavigate("/" + preLanguage + path + item?.id) : null
                                    }}
                                >
                                    {/* First Row */}
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center">
                                            {dynamicFields.map((field, fieldIndex) => {
                                                if (Object.keys(item).includes(field)) {
                                                    if (field === "Invoice") {
                                                        return (
                                                            <div className="flex items-center" style={{ gap: '6px' }} key={`${itemIndex}-${field}`}>
                                                                <div className="flex items-center justify-center" style={{ width: "24px", height: "24px", borderRadius: "4px", backgroundColor: "#E7F1F1" }}>
                                                                    {modules === "Sales" ? <SalesIcons /> : <PurchasesIconMobile />}
                                                                </div>
                                                                <p className="font-inter text-main" style={{ fontSize: "14px", fontWeight: "600", lineHeight: "22px" }}>
                                                                    #{item[field]}
                                                                </p>
                                                            </div>
                                                        );
                                                    }
                                                    if ((field === "No" || field === "Nr" || field === "Code") && (modules !== "Tax" && modules !== "Locations")) {
                                                        return (
                                                            <div className="flex items-center" style={{ marginRight: '6px' }} key={`${itemIndex}-${field}`}>
                                                                <div className="flex items-center justify-center" style={{ width: "24px", height: "24px", borderRadius: "4px", backgroundColor: "#E7F1F1" }}>
                                                                    <p className="font-inter text-main" style={{ fontSize: "14px", fontWeight: "600", lineHeight: "22px" }}>
                                                                        {item[field]}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                    if (field === "Code" && (modules === "Tax" || modules === "Locations")) {
                                                        return (
                                                            <React.Fragment key={`${itemIndex}-${field}`}>
                                                                <div className="flex items-center">
                                                                    <p className="font-inter text-main" style={{ fontSize: "14px", fontWeight: "600", lineHeight: "22px" }}>
                                                                        {item[field]}
                                                                    </p>
                                                                </div>
                                                                <div style={{ marginLeft: "4px" }}><DotIconBlack /></div>
                                                            </React.Fragment>
                                                        );
                                                    }
                                                    if (field === "Name" || field === "Title" || field === "Hierarchy" || field === "Product" || field === "Date" || field === "Tran") {
                                                        return (
                                                            <div className="flex items-center" key={`${itemIndex}-${field}`}>
                                                                <p className="font-inter text-main" style={{ fontSize: "14px", fontWeight: "600", lineHeight: "22px" }}>
                                                                    {item[field]}
                                                                </p>
                                                            </div>
                                                        );
                                                    }
                                                }
                                                return null;
                                            })}
                                        </div>
                                        <div className="flex items-center">
                                            {dynamicFields.map((field, fieldIndex) => {
                                                if (Object.keys(item).includes(field)) {
                                                    if ((field === "Balance" || field === "Price") && (modules === "Sales" || modules === "Assets") || (modules === "Stocks" && field === "Cost")) {
                                                        return (
                                                            <div className="flex items-center" key={`${itemIndex}-${field}`}>
                                                                <p className="font-inter text-main" style={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}>
                                                                    {item[field]}
                                                                </p>
                                                            </div>
                                                        );
                                                    }
                                                    if (field === "Total" || field === "Cost" || field === "Line Cost" || field === "Net Book Value" || field === "NET" || field === "TAX") {
                                                        return (
                                                            <div className="flex items-center" key={`${itemIndex}-${field}`}>
                                                                {(modules === "Sales" || modules === "Assets" || modules === "Stocks") && (
                                                                    <p
                                                                        className="font-inter text-main"
                                                                        style={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px", margin: "0px 4px" }}
                                                                    >
                                                                        /
                                                                    </p>
                                                                )}
                                                                <p
                                                                    className="font-inter text-main"
                                                                    style={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}
                                                                >
                                                                    {item[field]}
                                                                </p>
                                                                {(modules === "Ledger" && field !== "Total") && (
                                                                    <p
                                                                        className="font-inter text-main"
                                                                        style={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px", margin: "0px 4px" }}
                                                                    >
                                                                        /
                                                                    </p>
                                                                )}
                                                            </div>
                                                        );
                                                    }
                                                    if (field === "Status") {
                                                        return (
                                                            <React.Fragment key={`${itemIndex}-${field}`}>
                                                                {(modules === "Sales") && (
                                                                    <div style={{ height: "20px", width: "1px", backgroundColor: "#D1E4E5", margin: "0px 8px" }}></div>
                                                                )}
                                                                <TagStatus value={item.Status} />
                                                            </React.Fragment>
                                                        );
                                                    }
                                                }
                                                return null;
                                            })}
                                        </div>
                                    </div>

                                    {/* Second Row */}
                                    <div className="flex items-center justify-between w-full" style={{ margin: "8px 0px" }}>
                                        {dynamicFields.map((field, fieldIndex) => {
                                            if (Object.keys(item).includes(field)) {
                                                if (field === "Client" || field === "Company No" || field === "Category" || field === "Description" || field === "Email" || field === "Group" || field === "City" || field === "Product" || field === "Seller" || field === "Buyer") {
                                                    return (
                                                        <p className="font-inter text-main" style={{ fontSize: "14px", fontWeight: "600", lineHeight: "22px" }} key={`${itemIndex}-${field}`}>
                                                            {item[field]}
                                                        </p>
                                                    );
                                                }
                                            }
                                            return null;
                                        })}
                                    </div>

                                    {/* Third Row */}
                                    <div className="flex items-center w-full" style={{ gap: "6px" }}>
                                        {Object.keys(item).map((key, keyIndex, array) => {
                                            if (!dynamicFields.includes(key) && key !== "id" && key !== "default") {
                                                return (
                                                    <div className="flex items-center" style={{ gap: "6px" }} key={`${itemIndex}-${key}`}>
                                                        <p
                                                            className="font-inter text-main"
                                                            style={{
                                                                fontSize: "14px",
                                                                fontWeight: "600",
                                                                lineHeight: "22px",
                                                                color: key === "Qty" ? "#21A6AA" : "#7A7A7A"
                                                            }}
                                                        >
                                                            {String(item[key])}
                                                        </p>
                                                        {keyIndex < (modules !== "Assets" ? array.length - 2 : array.length - 3) && <DotIcon />}
                                                    </div>
                                                );
                                            }
                                            return null;
                                        })}
                                    </div>
                                </div>
                            );
                        })}
                    </>
                )}
            </div>
        </>
    );
};

export default TableReportMobile;